<template>
  <div class="mapRouteFormPanel">
    <div class="panel-main">
      <self-generated-form
        v-if="fieldsDefinition && currentShape && fieldsDefinition.data[currentShape.graphic_type]"
        v-model="currentShapeProperty"
        class="graphics__params"
        :graphic-id="currentShape.uuid"
        :fields="fieldsDefinition.data[currentShape.graphic_type]"
        :disabled="disabled"
        @change="onValueChanged"></self-generated-form>
    </div>
    <div class="btnGroup">
      <el-form ref="form" label-width="80px">
        <el-form-item label="点位过滤">
          <el-switch
            v-model="useFilter"
            active-color="#13ce66"
            inactive-color="#2c2c2f">
          </el-switch>
        </el-form-item>
        <div>
          <el-checkbox-group @change="onFilterChange" v-model="filterList">
            <el-checkbox label="PanoramaPoint">全景点({{{objects:allObjects,type:'PanoramaPoint'} | pointCountFilter}})</el-checkbox>
            <el-checkbox label="PanoramaPoint2">路口点({{{objects:allObjects,type:'PanoramaPoint2'} | pointCountFilter}})</el-checkbox>
            <el-checkbox label="Elevator">直梯({{{objects:allObjects,type:'Elevator'} | pointCountFilter}})&nbsp;&nbsp;</el-checkbox>
            <el-checkbox label="Escalator">扶梯({{{objects:allObjects,type:'Escalator'} | pointCountFilter}})&nbsp;&nbsp;</el-checkbox>
            <el-checkbox label="Screen">大屏({{{objects:allObjects,type:'Screen'} | pointCountFilter}})&nbsp;&nbsp;</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
import { LayerManager, eventHub } from '@aibee/vincent';
import axios from 'axios';
import SelfGeneratedForm from './self-generated-form.vue';
import fieldsDefinition from './fields';

export default {
  name: 'drawerMaterial',
  components: { SelfGeneratedForm },
  computed: {
    source() {
      return this.$route.params.source;
    },
  },
  data() {
    return {
      formData: {},
      radio: 3,
      fieldsDefinition: null,
      disabled: false,
      scale_level: null,
      currentShape: null,
      currentShapeProperty: {},
      useFilter: false,
      filterList: ['PanoramaPoint', 'PanoramaPoint2', 'Escalator', 'Elevator', 'Screen'],
      iconCount: {
        PanoramaPoint: 0,
        PanoramaPoint2: 0,
        Escalator: 0,
        Elevator: 0,
        Screen: 0,
      },
      allObjects: [],
    };
  },
  watch: {
    useFilter() {
      this.onFilterChange();
    },
    currentShapeProperty: {
      deep: true,
      handler(a) {
        if (this.currentShape && this.currentShape.type === 'CommonLine') {
          LayerManager.getCurrentLayer().getCanvas().requestRenderAll();
        }
      },
    },
  },
  created() {
    this.loadFields();
  },
  beforeDestroy() {
    eventHub.$off('routeCurrentShape');
    eventHub.$off('shape:add');
    eventHub.$off('shape:removed');
  },
  mounted() {
    eventHub.$on('routeCurrentShape', (shape) => {
      if (!shape) {
        this.currentShapeProperty = {};
        return;
      }
      this.currentShape = shape;
      this.currentShapeProperty = shape.property || {};
    });
    eventHub.$on('shape:add', this.onAddShape);
    eventHub.$on('shape:removed', this.onRemoveShape);
  },
  filters: {
    pointCountFilter: (data) => {
      // console.log(data.objects.map(item => item.property && item.property.type));
      let length;
      if (data.type === 'PanoramaPoint2') {
        length = data.objects.filter(item => item.type === 'PanoramaPoint' && item.property.is_route === '0').length;
      } else {
        length = data.objects.filter(item => item.type === data.type).length;
      }
      return length;
    }

    ,
  },
  methods: {
    onAddShape(objects) {
      this.allObjects = objects;
    },
    onRemoveShape(objects) {
      this.allObjects = objects;
    },
    onValueChanged(v) {
      // eslint-disable-next-line no-param-reassign
      if (!v) v = {};
      if (!this.currentShape.property) {
        this.currentShape.property = {};
      }
      Object.assign(this.currentShape.property, v);
      if (Object.prototype.hasOwnProperty.call(v, 'is_route')) this.allObjects = LayerManager.getCurrentLayer().getAllObjects();
    },
    loadFields() {
      // axios.get('/fields.json').then((res) => {
      //   console.log(res.data);
      //   this.fieldsDefinition = res.data;
      // });
      this.fieldsDefinition = fieldsDefinition;
    },
    onFilterChange(val) {
      LayerManager.getCurrentLayer().getAllObjects().forEach((item) => {
        if (this.useFilter && ['Elevator', 'Escalator', 'Screen', 'PanoramaPoint'].includes(item.type) && !this.filterList.includes(item.type)) {
          item.set('opacity', 0).setCoords();
        } else {
          item.set('opacity', 1).setCoords();
        }
      });
      LayerManager.getCurrentLayer().getCanvas().renderAll();
    },
    onSubmit() {

    },
    onCancel() {

    },
  },
};
</script>
<style lang="less" scoped>
  .mapRouteFormPanel {
    width: 280px;
    height: 100%;
    background-color: #1c1c1e;
    box-shadow: 1px 2px 2px 232323;
    z-index: 10;
    padding: 20px 30px 0 30px;
    box-sizing: border-box;
    overflow: auto;
    display: flex;
    flex-direction: column;

    .panel-main {
      flex: 1;
    }

    .btnGroup{
      height: 200px;
      width: 100%;
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      ::v-deep .el-button{
        width:45%;
      }
      ::v-deep .el-button+.el-button{
        margin-left: 0;
      }
      ::v-deep .el-button:first-child{
        background-color: #6979ed;
        &:hover{
          background-color: #8693f0;
          transition: background 0.2s;
        }
      }
    }

    .formItem{
      margin-bottom: 20px;
      &__title{
        color: #bfc0c7;
        font-size: 12px;
        margin: 10px 0;
        font-weight: 700;
      }
      ::v-deep .el-upload--picture-card{
        width: 80px;
        height: 80px;
        line-height: 90px;
        background-color: #1c1c1e;
      }
      ::v-deep .el-upload-list__item{
        width: 80px;
        height: 80px;
      }
    }
  }
</style>
<style lang="less">
.mapRouteFormPanel {
  .btnGroup {
    .el-form-item {
      margin-bottom: 10px;
      .el-form-item__label {
        text-align: left;
        color: #dddddd;
        font-size: 14px;
      }
      .el-form-item__content {
        text-align: right;
      }
    }


    .el-checkbox-group {
      .el-checkbox {
        margin-bottom: 10px;
      }
      .el-checkbox__label {
        color: #aaaaaa;
        width: 60px;
      }
      .is-checked {
        .el-checkbox__inner {
          border-color: #bbbbbb;
        }
        .el-checkbox__label {
          color: #bbbbbb;
        }
      }
    }
  }
}
</style>
